import { UiSchema } from "@rjsf/utils";

export const FormSettingsUiSchema: UiSchema = {
  formSchema: {
    formSchema: {
      "ui:widget": "textarea"
    },
    uiSchema: {
      "ui:widget": "textarea"
    }
  }
};
